/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-debugger */
/* eslint-disable no-unsafe-optional-chaining */
import {
  SimpleGrid,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Select,
  Link,
  FormHelperText,
  HStack,
  Checkbox,
  Button,
  VStack,
  Spinner,
  Box,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,

  InputGroup,
  InputRightElement,
  IconButton,} from '@chakra-ui/react';
import Tooltip from '../../../../components/Tooltip';
import { t } from 'i18next';
import { handleIsInvalidField } from '../../Login/Login';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import { useState, useMemo, useEffect, useRef } from 'react';
import {
  FormFieldType,
  FormType,
  Location,
  Reservation,
  ReservationFormFields,
  ReservationStatus,
  Reservations,
} from '~/core/types';
import useLocations from '~/hooks/useLocations';
import useFormFields from '~/hooks/useFormFields';
import useReservartionFormYup from '~/hooks/useReservationFormYup';
import useStartHours from '~/hooks/useStartHours';
import useLang from '~/hooks/useLang';
import useEndHours from '~/hooks/useEndHours';
import {
  formatDate,
  formatHourWithPeriod,
  getDatetimeFromString,
  getHoursInRange,
  getTimestampZonedTimeToUtc,
  getZonedTime,
} from '~/utils/date';
import { addMinutes, endOfDay, format, startOfDay, subDays } from 'date-fns';
import { Timestamp, collection, query, where, getDocs } from 'firebase/firestore';
import firebaseFirestore from '~/config/firebase/firestore';
import useGetParam from '~/hooks/useGetParam';
import { createReservation, updateReservation } from './repositories/reservationRepository';
import { occupySlots, SlotUnavailableError } from './repositories/occupancyRepository';
import { franjasDeBloque } from './repositories/franjas';
import { useForm as useFormHook } from '~/hooks/useForm';
import FormSuccesfullSent from './components/FormSuccesfullSent';
import AgregarACalendario from './calendario/AgregarACalendario';

import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import { useAuth } from '~/hooks/useAuth';
import BuscarCliente, { FichaCliente } from './components/BuscarCliente';
import { useErrorLogs } from '~/hooks/useErrorLogs';
import { useActivityLogs } from '~/hooks/useActivityLogs';
import { useCompanyStatus } from '~/hooks/useCompanyStatus';
import {
  registrarEvento,
  describirActor,
  compararReserva,
} from '~/core/tracking/reservationEvents';


type ReservationFormProps = {
  reservation?: ReservationFormFields | undefined;
};

const ReservationForm = ({ reservation }: ReservationFormProps) => {
  const lang = useLang();
  const { user } = useAuth();
  const { logActivity } = useActivityLogs();
  const { isLoading: isCompanyStatusLoading, companyStatus } = useCompanyStatus();

  const from = useGetParam('from');
  const companyId = useGetParam('company');

  const { changeForm } = useFormHook();

  // Get dynamic fields from company
  const [fields] = useFormFields(companyId);
  const [location, setLocation] = useState<Location>();
  const schema = useReservartionFormYup(fields, location!);

  // manage modal of the last reservation
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [lastReservation, setLastReservation] = useState<Reservation>();

  const [reservationStatus, setReservationStatus] = useState<ReservationStatus>(
    ReservationStatus.PENDING
  );

  const [reservationCreated, setReservationCreated] = useState<Partial<ReservationFormFields>>();

  /**
   * "Esta reserva se repite": solo para quien está dentro del panel.
   *
   * No crea nada por sí misma. Al guardar la reserva se avisa al panel, que
   * abre la ventana de repetición con la reserva ya creada delante. Así el
   * formulario público se queda exactamente como estaba.
   */
  const [esRecurrente, setEsRecurrente] = useState(false);
  const puedeRepetir = Boolean(user?.uid) && !reservation;

  /**
   * Buscador de clientes anteriores: solo con sesión, y solo en los campos por
   * los que tiene sentido buscar a alguien.
   */
  const [buscandoCliente, setBuscandoCliente] = useState(false);
  // El celular no se llama igual en todos los formularios ('phone' en unos,
  // 'phoneNumber' en otros), así que se contemplan los dos.
  const CAMPOS_CON_LUPA = [
    'namesAndSurnames', 'companyName', 'email', 'identificationNumber', 'phone', 'phoneNumber',
  ];
  const puedeBuscarCliente = (slug?: string) =>
    Boolean(user?.uid) && Boolean(slug) && CAMPOS_CON_LUPA.includes(slug as string);

  /** Vuelca los datos del cliente elegido en el formulario. */
  const rellenarConCliente = (ficha: FichaCliente) => {
    const valores: Record<string, unknown> = {
      ...ficha.extra,
      ...(ficha.nombre ? { namesAndSurnames: ficha.nombre } : {}),
      ...(ficha.empresa ? { companyName: ficha.empresa } : {}),
      ...(ficha.correo ? { email: ficha.correo, emailConfirmation: ficha.correo } : {}),
      ...(ficha.documento ? { identificationNumber: ficha.documento } : {}),
      ...(ficha.telefono ? { phone: ficha.telefono, phoneNumber: ficha.telefono } : {}),
      ...(ficha.direccion ? { billingAddress: ficha.direccion } : {}),
    };
    // No se tocan sala, día ni hora: eso lo está eligiendo quien reserva ahora.
    // Solo se rellenan campos que el formulario de este negocio tenga; los
    // demás se ignoran en vez de ensuciar el estado.
    const slugsDelFormulario = new Set(fields.map((f) => f.slug).filter(Boolean) as string[]);
    slugsDelFormulario.add('emailConfirmation');
    Object.entries(valores).forEach(([clave, valor]) => {
      if (valor === undefined || valor === null || valor === '') return;
      if (!slugsDelFormulario.has(clave)) return;
      setValue(clave, valor as never, { shouldValidate: false });
    });
    toast.success(`Datos de ${ficha.nombre} cargados`);
  };
  const [updateLocationStatus, setUpdateLocationStatus] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const { i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const source = useGetParam('source');
  const { logError } = useErrorLogs();

  // Check if company is active - disable form if company is inactive
  const isFormDisabled = companyStatus === 'inactive';

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm<ReservationFormFields>({
    mode: 'onBlur',
    resolver: yupResolver(schema),

    // En desarrollo el formulario venía relleno con unos datos fijos de prueba.
    // Estorbaban más que ayudaban: al abrir una reserva existente pisaban los
    // datos del cliente, así que en dev nunca se veía a quién pertenecía. Para
    // probar rápido está el botón "Autocompletar formulario", que usa los datos
    // que cada negocio configura.
    defaultValues: {
      ...reservation,
      ...(reservation?.location ? { startHour: '00:00' } : {}),
      ...Object.fromEntries(searchParams.entries()),
      emailConfirmation: searchParams.get('email') ?? '',
    },
  });

  const watchNumberPeople = watch('numberPeople');
  const watchLocation = watch('location');
  const watchDate = watch('date') as string;
  const watchStartHour = watch('startHour');

  const watchEmail = watch('email');
  const watchEmailConfirmation = watch('emailConfirmation');

  const [locations, , locationsCloneRef, getLocations] = useLocations({
    watchNumberPeople,
    update: updateLocationStatus,
  });

  const [startHours, hoursAvailable, helpTextHour, getStartHoursAvailable] = useStartHours({
    watchDate,
    watchNumberPeople: +watchNumberPeople,
    location,
    reservation,
    allowPreviewHours: user?.role && reservation?.location ? true : false,
    previewHours: 10,
  });

  const [endHours, getEndHoursAvailable] = useEndHours({
    watchDate,
    watchNumberPeople,
    watchStartHour,
    hoursAvailable,
    location,
    reservation,
  });

  useEffect(() => {
    if (watchNumberPeople && locations.length === 1) {
      setLocation(locations[0]);
      setValue('location', locations[0].id);
    }
  }, [watchNumberPeople, locations]);

  const isEndDateEnable = useMemo(() => {
    return location?.schedule?.settings?.isEndDateEnable ?? false;
  }, [location]);

  const _getReservationsForDate = async ({ email, locationId, date }: any) => {
    const fechaInicio: Date = startOfDay(date);
    const fechaFin = endOfDay(date);
    const timestampInicio = Timestamp.fromDate(fechaInicio);
    const timestampFin = Timestamp.fromDate(fechaFin);
    const reservationRef = collection(firebaseFirestore, 'reservations');
    const q = query(
      reservationRef,
      ...[
        where('email', '==', email),
        where('location.id', '==', locationId),
        where('datetime', '>=', timestampInicio),
        where('datetime', '<=', timestampFin),
      ]
    );
    const querySnapshot = await getDocs(q);
    let documents = querySnapshot.docs;
    if (documents.length > 0) {
      documents = documents.filter((doc) => {
        return (doc.data() as Reservation).status != 'cancelled';
      });
    }

    return documents;
  };

  const _onGoReservation = () => {
    window.location.href = `./reservations/${lastReservation?.code}`;
  };

  const onSubmit = async (data: ReservationFormFields) => {
    // Fuera del try: si algo falla después de crearla, el catch necesita saber
    // qué reserva limpiar.
    let reservationId = '';
    try {
      setIsLoading(true);

      const { date, startHour, endHour } = data;
      const startDatetime = getDatetimeFromString(date as string, startHour) ?? new Date();

      const isEndDateEnable = location?.schedule?.settings?.isEndDateEnable ?? false;

      const isReservationWholeDay = location?.schedule?.settings?.isReservationWholeDay ?? false;
      const blockTimeMinutes = location?.schedule?.settings?.blockTimeMinutes ?? 0;
      let hoursList = getHoursInRange(startHour, endHour);

      let newEndDateBlocTimeMinutes;
      if (!endHour && blockTimeMinutes) {
        newEndDateBlocTimeMinutes = addMinutes(startDatetime, blockTimeMinutes);
        // La misma cuenta que usa el desplegable de horas para decidir qué
        // ofrece (ver `franjasDeBloque`): si aquí se exigiera algo distinto,
        // se ofrecerían horas que luego se rechazan.
        hoursList = franjasDeBloque({
          startHour,
          blockTimeMinutes,
          primeraHora: hoursAvailable[0].value,
          ultimaHora: hoursAvailable[hoursAvailable.length - 1].value,
        });
      } else {
        //find last hour available
        const lastHour = hoursAvailable[hoursAvailable.length - 1];
        const lastHourFound = hoursList.find((hour) => hour === lastHour.value);
        if (!lastHourFound) {
          //if not found last hour in  hoursList then remove last hour in it
          hoursList.pop();
        }
      }

      // Una reserva tiene que bloquear al menos una franja. `getHoursInRange`
      // devuelve una lista VACÍA si falta la hora de fin o si el fin va antes
      // que el inicio, y con la lista vacía no se comprueba ni se ocupa nada:
      // la sala quedaría libre para todos y nadie vería el choque.
      //
      // Con las tres configuraciones de NOI no ocurre —probadas las 676
      // combinaciones de sus 11 sedes—, pero una sala nueva sin "hora fin",
      // sin bloqueo y sin día completo caería aquí.
      if (!isReservationWholeDay && hoursList.length === 0) {
        setIsLoading(false);
        toast.error(
          'No se pudo calcular el horario de esta reserva. ' +
            'Avisa a Sontickets: falta configurar la hora de fin de este espacio.'
        );
        return;
      }

      if (!isEndDateEnable && !isReservationWholeDay) {
        const reservationsForDate = await _getReservationsForDate({
          email: data.email,
          locationId: data.location,
          date: startDatetime,
        });

        if (reservationsForDate.length > 0 && !reservation) {
          setIsLoading(false);
          onOpen();
          setLastReservation(reservationsForDate[0].data() as Reservation);
          return;
        }
      }

      const firebaseStartTimestamp = getTimestampZonedTimeToUtc(startDatetime);
      const zonedStartHour = getZonedTime(firebaseStartTimestamp.toDate());
      let endHourFormat = '--';
      let firebaseEndTimestamp = null;
      if (isEndDateEnable) {
        const endDatetime = getDatetimeFromString(date as string, endHour);
        firebaseEndTimestamp = getTimestampZonedTimeToUtc(endDatetime!);
        endHourFormat = formatHourWithPeriod(firebaseEndTimestamp.toDate(), '');
      }

      if (newEndDateBlocTimeMinutes) {
        firebaseEndTimestamp = getTimestampZonedTimeToUtc(newEndDateBlocTimeMinutes);
      }

      const locationFound = {
        ...(locationsCloneRef.current.find((location) => {
          return location.id === data.location;
        }) ?? ({} as Location)),
      };

      delete locationFound?.reservations;
      delete locationFound?.schedule;

      const newReservation = {
        ...data,
        //deprecated next version ${ datetime} ${time}
        datetime: firebaseStartTimestamp,
        time: formatHourWithPeriod(zonedStartHour),
        //end deprecated next version ${ datetime} ${time}
        startDate: formatDate(startDatetime),
        startHour: formatHourWithPeriod(zonedStartHour, ''),
        startDatetime: firebaseStartTimestamp,
        endDate: isEndDateEnable ? formatDate(firebaseEndTimestamp?.toDate() ?? new Date()) : '',
        endHour: endHourFormat,
        endDatetime: firebaseEndTimestamp,
        location: locationFound,
        from,
        // La fecha de creación solo se pone al crear. Estaba puesta también
        // sin condición justo encima, así que cada modificación la pisaba con
        // la fecha del momento: medido en producción, 1.886 reservas dicen
        // haberse creado DESPUÉS de confirmarse, una hasta 20 días después.
        ...(!reservation ? { createdAt: Date.now() } : {}),
        updatedAt: Date.now(),
        status: 'pending',
        isUpdatedByUser: false,
        lang,
        source,
      };

      let reservations = location?.reservations;
      let locationId = locationFound?.id;

      const formattedStartDate = formatDate(startDatetime);
      const personHasSpecificPosition =
        location?.schedule?.settings?.personHasSpecificPosition ?? false;

      let reservationCode = '';

      //check if there is a reservation with the same date and hour
      const locations = await getLocations();

      const locToVal = locations.find((location) => location.id === data.location);
      const startHours = getStartHoursAvailable({
        location: locToVal,
        watchDate,
        watchNumberPeople: +watchNumberPeople,
        allowPreviewHours: user?.role && reservation?.location ? true : false,
        previewHours: 10,
        reservation,
      });

      const isOcuppiedStartHour = startHours.find(
        (hour) => hour.value === newReservation.startHour
      )?.disabled;

      const endHours = getEndHoursAvailable({
        watchDate,
        watchNumberPeople,
        watchStartHour,
        hoursAvailable: startHours,
        location: locToVal,
        reservation,
      });

      const isOccupiedEndHour = endHours.find(
        (hour) => hour.value === newReservation.endHour
      )?.disabled;

      if (isOcuppiedStartHour || isOccupiedEndHour) {
        setValue('location', '');
        await new Promise((resolve) => {
          setTimeout(() => {
            setValue('location', data.location);
            resolve(true);
          }, 1000);
        });

        alert('La hora seleccionada ya fue reservada, por favor seleccione otra hora');

        throw new Error(
          `${locationFound.name} La hora ${newReservation?.startHour} seleccionada ya fue reservada, por favor seleccione otra hora`
        );
      }

      if (!reservation) {
        // Se sella quién la crea en la propia reserva: hasta ahora solo quedaba
        // en los registros, y por eso no se podía saber de quién era una reserva
        // mirándola. `from` dice desde dónde; esto dice quién.
        // Si va a repetirse, la reserva nace sin código: así no sale su propio
        // correo y el cliente recibe uno solo, ya con todas las fechas. El
        // código se le pone al cerrar la serie (ver `crearSerie`), y si se
        // cancela la repetición se le pone igual y todo sigue como siempre.
        const { reservationRefCreated, code } = await createReservation(
          {
            ...newReservation,
            createdBy: describirActor(user),
          },
          esRecurrente && !reservation ? { escribirCodigo: false } : undefined
        );
        reservationId = reservationRefCreated.id;
        reservationCode = code;

        // Log the reservation creation activity
        await logActivity({
          activityType: 'reservation_create',
          entityId: reservationId,
          entityType: 'reservation',
          locationId: locationFound?.id,
          details: {
            reservationCode,
            customerName: data.namesAndSurnames || '',
            numberPeople: data.numberPeople,
            startDate: formatDate(startDatetime),
            startHour: formatHourWithPeriod(zonedStartHour, ''),
            endDate: isEndDateEnable
              ? formatDate(firebaseEndTimestamp?.toDate() ?? new Date())
              : '',
            endHour: endHourFormat,
            from: from || 'website',
          },
        });

        // Rastro ligero y con autor (ver core/tracking/reservationEvents.ts).
        await registrarEvento({
          tipo: 'created',
          reservationId,
          code: reservationCode,
          companyId,
          locationId: locationFound?.id,
          locationName: locationFound?.name,
          usuario: user,
          origen: { from },
          cliente: { nombre: data.namesAndSurnames, correo: data.email },
        });
      } else {
        const reservationCurrentLocation = reservation?.location as Location;
        let reservationsUpdated: Reservations | undefined = { ...reservations };

        // Capture initial state for comprehensive logging
        const modificationProcess = {
          startTime: Date.now(),
          isLocationChanging: reservationCurrentLocation?.id !== data.location,
          isTimeChanging: false,
          currentState: {
            location: {
              id: reservationCurrentLocation?.id,
              name: reservationCurrentLocation?.name,
            },
            dateTime: {
              startDate: formatDate((reservation.startDatetime as Timestamp).toDate()),
              startHour: reservation.startHour,
              endDate: reservation.endDatetime
                ? formatDate((reservation.endDatetime as Timestamp).toDate())
                : '',
              endHour: reservation.endHour,
            },
            numberPeople: reservation.numberPeople,
          },
          newState: {
            location: {
              id: locationFound?.id,
              name: locationFound?.name,
            },
            dateTime: {
              startDate: formatDate(startDatetime),
              startHour: formatHourWithPeriod(zonedStartHour, ''),
              endDate: isEndDateEnable
                ? formatDate(firebaseEndTimestamp?.toDate() ?? new Date())
                : '',
              endHour: endHourFormat,
            },
            numberPeople: data.numberPeople,
          },
          locationReservations: {
            beforeUpdate: {} as any,
            afterUpdate: {} as any,
          },
          locationUpdates: [] as any[],
          errors: [] as any[],
        };

        // Check if hours are changing
        modificationProcess.isTimeChanging =
          reservation.startHour !== formatHourWithPeriod(zonedStartHour, '') ||
          reservation.endHour !== endHourFormat;

        const locations = await getLocations();
        const locationFoundInternal = locations.find((location) => location.id === data.location);

        if (reservation && reservationCurrentLocation?.id !== locationFoundInternal?.id) {
          reservationsUpdated = locations.find(
            (location) => location.id === reservationCurrentLocation?.id
          )?.reservations;
          locationId = reservationCurrentLocation?.id;
        }

        //update current location reservations when the location is changed or keep the same
        reservationId = reservation.id as string;
        reservationCode = reservation.code as string;

        const reservationStartDate = formatDate((reservation.startDatetime as Timestamp).toDate());

        // Capture location reservations state BEFORE any updates
        modificationProcess.locationReservations.beforeUpdate = JSON.parse(
          JSON.stringify(reservationsUpdated || {})
        );

        // Capture location updates for logging
        const beforeUpdate = JSON.stringify(reservationsUpdated || {});

        // La reserva se retira de sus franjas anteriores dentro de la misma
        // transacción que la vuelve a colocar (ver `occupySlots` más abajo),
        // para que no quede un instante en el que ocupe dos sitios ni se
        // pierda lo que otras personas hayan reservado entre medias.

        // Capture after update state
        const afterUpdate = JSON.stringify(reservationsUpdated || {});

        // Capture location reservations state AFTER updates
        modificationProcess.locationReservations.afterUpdate = JSON.parse(
          JSON.stringify(reservationsUpdated || {})
        );

        modificationProcess.locationUpdates.push({
          type: 'location_data_update',
          locationId: locationId,
          beforeState: beforeUpdate,
          afterState: afterUpdate,
          affectedDates: [reservationStartDate, formattedStartDate],
        });

        await updateReservation(reservation.id as string, {
          ...newReservation,
          updatedBy: describirActor(user),
        });

        // Log comprehensive modification record
        await logActivity({
          activityType: 'reservation_modification_complete',
          entityId: reservation?.id as string,
          entityType: 'reservation',
          locationId: locationFoundInternal?.id,
          details: {
            // Basic information
            reservationId: reservation?.id,
            reservationCode: reservation?.code,
            customerName: data.namesAndSurnames || '',
            processedAt: new Date().toISOString(),
            processingTime: Date.now() - modificationProcess.startTime,

            // Modification summary
            modifications: {
              isLocationChanging: modificationProcess.isLocationChanging,
              isTimeChanging: modificationProcess.isTimeChanging,
              isNumberPeopleChanging:
                modificationProcess.currentState.numberPeople !==
                modificationProcess.newState.numberPeople,
            },

            // Previous state
            previousReservation: {
              id: reservation.id,
              location: modificationProcess.currentState.location,
              dateTime: modificationProcess.currentState.dateTime,
              numberPeople: modificationProcess.currentState.numberPeople,
              startDate: formatDate((reservation.startDatetime as Timestamp).toDate()),
              startHour: reservation.startHour,
              endDate: reservation.endDatetime
                ? formatDate((reservation.endDatetime as Timestamp).toDate())
                : '',
              endHour: reservation.endHour,
            },

            // New state
            updatedReservation: {
              id: reservationId,
              location: modificationProcess.newState.location,
              dateTime: modificationProcess.newState.dateTime,
              numberPeople: modificationProcess.newState.numberPeople,
              startDate: newReservation.startDate,
              startHour: newReservation.startHour,
              endDate: newReservation.endDate,
              endHour: newReservation.endHour,
            },

            // Location reservations data (before and after) - focused on affected dates only
            locationReservationsData: {
              locationId: locationId,
              affectedDates: [reservationStartDate, formattedStartDate],
              beforeUpdate: {
                [reservationStartDate]:
                  modificationProcess.locationReservations.beforeUpdate[reservationStartDate] ?? [],
                [formattedStartDate]:
                  modificationProcess.locationReservations.beforeUpdate[formattedStartDate] ?? [],
              },
              afterUpdate: {
                [reservationStartDate]:
                  modificationProcess.locationReservations.afterUpdate[reservationStartDate] ?? [],
                [formattedStartDate]:
                  modificationProcess.locationReservations.afterUpdate[formattedStartDate] ?? [],
              },
            },

            // Location updates performed
            locationUpdates: modificationProcess.locationUpdates,

            // Form data submitted
            formData: {
              location: data.location,
              date: data.date,
              startHour: data.startHour,
              endHour: data.endHour,
              numberPeople: data.numberPeople,
              email: data.email,
            },

            // System context
            systemInfo: {
              userAgent: navigator.userAgent,
              url: window.location.href,
              timestamp: new Date().toISOString(),
            },

            // Errors encountered (if any)
            errors: modificationProcess.errors,
          },
        });

        // El mismo cambio, pero contado en un evento de menos de 1 KB: solo los
        // campos que de verdad cambiaron, nunca el mapa de ocupación.
        const antes = {
          location: modificationProcess.currentState.location.name,
          startDate: modificationProcess.currentState.dateTime.startDate,
          startHour: modificationProcess.currentState.dateTime.startHour,
          endDate: modificationProcess.currentState.dateTime.endDate,
          endHour: modificationProcess.currentState.dateTime.endHour,
          numberPeople: modificationProcess.currentState.numberPeople,
        };
        const despues = {
          location: modificationProcess.newState.location.name,
          startDate: modificationProcess.newState.dateTime.startDate,
          startHour: modificationProcess.newState.dateTime.startHour,
          endDate: modificationProcess.newState.dateTime.endDate,
          endHour: modificationProcess.newState.dateTime.endHour,
          numberPeople: modificationProcess.newState.numberPeople,
        };
        await registrarEvento({
          tipo: 'modified',
          reservationId: reservation.id as string,
          code: reservation.code as string,
          companyId,
          locationId: locationFoundInternal?.id,
          locationName: locationFoundInternal?.name,
          usuario: user,
          origen: { from },
          cambios: compararReserva(antes, despues),
          cliente: { nombre: data.namesAndSurnames, correo: data.email },
        });
      }

      // ── Ocupación de la agenda ─────────────────────────────────────────
      // Se hace dentro de una transacción: lee el estado real de la sala,
      // comprueba que las franjas siguen libres y escribe, todo como una
      // sola operación indivisible. Si otra persona reservó mientras tanto,
      // `occupySlots` lanza SlotUnavailableError y no se escribe nada.
      const hoursToOccupy = isReservationWholeDay
        ? getHoursInRange('00:00', '23:59')
        : hoursList;

      // Plazas que consume la reserva en cada franja: una por persona cuando
      // el espacio asigna posición (zonas de coworking), o una sola cuando la
      // sala es de uso exclusivo.
      const seatsPerSlot =
        personHasSpecificPosition || isReservationWholeDay ? +data.numberPeople : 1;

      await occupySlots({
        locationId: locationFound?.id ?? '',
        date: formattedStartDate,
        hours: hoursToOccupy,
        reservationId,
        seatsPerSlot,
        limit: location?.schedule?.settings?.numberBookingsAllow ?? 1,
        locationName: locationFound?.name,
        // Al modificar una reserva se retira de las franjas que ocupaba antes
        // dentro de la misma transacción que la recoloca.
        ...(reservation
          ? {
              release: {
                locationId:
                  (reservation.location as Location)?.id ?? locationFound?.id ?? '',
                dates: [
                  formatDate((reservation.startDatetime as Timestamp).toDate()),
                  formattedStartDate,
                ],
              },
            }
          : {}),
      });

      window.dataLayer.push({
        event: 'reservation-created',
      });

      // El panel escucha este aviso y abre la ventana de repetición. Se manda
      // un evento en vez de pasar funciones por media aplicación: el formulario
      // vive tres niveles por debajo y no conoce al panel.
      if (esRecurrente && !reservation && reservationId) {
        window.dispatchEvent(
          new CustomEvent('sontickets:repetir-reserva', {
            // El código va aquí porque todavía no está escrito en la reserva.
            detail: { reservationId, codigoPendiente: reservationCode },
          })
        );
      }

      setReservationCreated({
        id: reservationId,
        name: data.namesAndSurnames,
        date: startDatetime,
        startHour: formatHourWithPeriod(zonedStartHour, ''),
        endHour: endHourFormat,
        code: reservationCode,
      });

      setIsLoading(false);
      if (reservation) {
        toast.success(t('general.text_updated_reservation'));
        const buttonRef = document.querySelector<HTMLButtonElement>('#button-search-reservation');
        buttonRef?.click();
      } else {
        reset();
        setReservationStatus(ReservationStatus.CONFIRMED);
      }
    } catch (error) {
      setIsLoading(false);

      // Alguien ocupó esa franja mientras se rellenaba el formulario. Se avisa
      // y se recargan los horarios con el estado real, para que elija otro sin
      // perder lo que ya había escrito.
      if (error instanceof SlotUnavailableError) {
        // La reserva se crea ANTES de ocupar las franjas, así que si la
        // ocupación falla queda un documento que aparece en el panel pero no
        // bloquea nada: otra persona podría reservar encima. Se cancela.
        if (!reservation && reservationId) {
          try {
            await updateReservation(reservationId, {
              status: 'cancelled',
              cancelledBy: 'system',
              cancelledAt: new Date(),
              updatedAt: Date.now(),
            });
          } catch {
            /* si no se puede cancelar, el aviso al usuario sigue siendo lo primero */
          }
        }

        toast.error(error.message);
        setValue('startHour', '');
        setValue('endHour', '');

        const refreshed = await getLocations();
        const current = refreshed.find((item) => item.id === data.location);
        if (current) setLocation({ ...current });

        return;
      }

      // Log detailed error information for debugging
      await logActivity({
        activityType: 'reservation_error',
        entityId: reservation?.id ? String(reservation.id) : 'unknown',
        entityType: 'reservation',
        locationId:
          typeof data.location === 'string'
            ? data.location
            : String((data.location as any)?.id || data.location),
        details: {
          errorMessage: (error as Error).message,
          errorStack: (error as Error).stack,
          reservationId: reservation?.id ? String(reservation.id) : '',
          reservationCode: reservation?.code ? String(reservation.code) : '',
          customerName: data.namesAndSurnames ? String(data.namesAndSurnames) : '',
          attemptedOperation: reservation ? 'update_reservation' : 'create_reservation',
          formData: {
            location: String(data.location),
            date: String(data.date),
            startHour: String(data.startHour || ''),
            endHour: String(data.endHour || ''),
            numberPeople: String(data.numberPeople || ''),
            email: String(data.email || ''),
          },
          locationInfo: {
            currentLocationId: reservation
              ? String((reservation.location as Location)?.id || '')
              : '',
            newLocationId: String(data.location),
          },
          systemInfo: {
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString(),
            url: window.location.href,
          },
          reservationState: {
            isExistingReservation: !!reservation,
            wasLocationChanging: reservation
              ? String((reservation.location as Location)?.id || '') !== String(data.location)
              : false,
          },
        },
      });

      await logError(error as Error);
    }
  };

  const handlePopulateForm = () => {
    const defaultFields = user?.company?.others?.populateForm?.fields;
    if (defaultFields) {
      Object.entries(defaultFields ?? {}).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
    setValue('emailConfirmation', watch('email') ?? '');
  };

  useEffect(() => {
    if (reservation) {
      const locationSelected = locationsCloneRef.current.find((location) => {
        return location.id === (reservation.location as Location).id;
      });

      setLocation(locationSelected);

      i18n.changeLanguage((reservation.lang as string) ?? 'es');
      setSearchParams({
        lang: (reservation.lang as string) ?? 'es',
        company: companyId,
      });

      setTimeout(() => {
        setValue('location', locationSelected?.id ?? '');
      }, 1000);
    }
  }, [reservation, locations]);

  useEffect(() => {
    if (watchLocation) {
      const locationSelected = locationsCloneRef.current.find((location) => {
        return location.id === watchLocation;
      });

      setLocation(locationSelected);
    }
    // También cuando terminan de cargar las sedes: si la sala viene puesta de
    // entrada (por ejemplo al abrir el formulario desde el calendario), este
    // efecto corría antes de que la lista existiera y la sala se quedaba sin
    // reconocer, así que no aparecía ninguna hora. Es el mismo patrón que usa
    // el efecto de edición, unas líneas más arriba.
  }, [watchLocation, locations]);

  /**
   * Horario que viene puesto de fuera (al abrir el formulario desde el
   * calendario, arrastrando sobre un hueco libre).
   *
   * Los desplegables de hora nacen vacíos y solo se llenan cuando ya se sabe
   * la sala y la fecha. Un `<select>` descarta un valor que todavía no existe
   * entre sus opciones, así que la hora de la URL se perdía. Aquí se repone en
   * cuanto la opción aparece, una sola vez, y solo si sigue libre: si entre
   * medias alguien ocupó esa franja, se deja vacío para que la persona elija.
   *
   * Sin parámetros en la URL este efecto no hace absolutamente nada.
   */
  const horaUrl = searchParams.get('startHour');
  const horaFinUrl = searchParams.get('endHour');
  const horaRepuesta = useRef(false);
  const horaFinRepuesta = useRef(false);

  useEffect(() => {
    // Se marca como hecho SOLO cuando la hora se pone de verdad. Las horas se
    // recalculan varias veces mientras llegan la sala y su agenda; si se diera
    // por hecho en el primer intento, una hora que aparece en el segundo
    // cálculo se perdería para siempre.
    //
    // No se mira si "ya hay hora": el formulario guarda internamente la hora de
    // la URL aunque el desplegable la haya descartado, así que preguntárselo
    // hacía creer que ya estaba puesta y no se reponía nunca.
    if (horaRepuesta.current || !horaUrl || startHours.length === 0) return;
    const libre = startHours.find((hora) => hora.value === horaUrl && !hora.disabled);
    if (!libre) return;
    setValue('startHour', horaUrl);
    horaRepuesta.current = true;
  }, [startHours, horaUrl, setValue]);

  useEffect(() => {
    if (horaFinRepuesta.current || !horaFinUrl || endHours.length === 0) return;
    const libre = endHours.find((hora) => hora.value === horaFinUrl && !hora.disabled);
    if (!libre) return;
    setValue('endHour', horaFinUrl);
    horaFinRepuesta.current = true;
  }, [endHours, horaFinUrl, setValue]);

  useEffect(() => {
    //set chakra ui background transparent
    setTimeout(() => {
      const chakraUi = document.querySelector<HTMLElement>('.chakra-ui-light');

      if (chakraUi) {
        chakraUi.style.backgroundColor = 'transparent';
      }
    }, 100);
  }, []);

  useEffect(() => {
    const triggerEmail = async () => {
      await trigger('email');
      await trigger('emailConfirmation');
    };
    if (watchEmail && watchEmailConfirmation) {
      if (watchEmail == watchEmailConfirmation) {
        triggerEmail();
      } else {
        trigger('emailConfirmation');
      }
    }
  }, [watchEmail, watchEmailConfirmation]);

  if (reservationStatus === ReservationStatus.CONFIRMED) {
    return (
      <FormSuccesfullSent
        onBack={async () => {
          setReservationStatus(ReservationStatus.PENDING);
          setUpdateLocationStatus(true);
        }}
        reservationId={reservationCreated?.id as string}
      />
    );
  }

  // Show loading while checking company status
  if (isCompanyStatusLoading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
        <VStack>
          <Spinner size='lg' />
          <Text>Verificando estado de la empresa...</Text>
        </VStack>
      </Box>
    );
  }

  // Show message if company is inactive
  if (isFormDisabled) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
        <VStack spacing={4} textAlign='center'>
          <Text fontSize='xl' fontWeight='bold' color='red.500'>
            Servicio no disponible
          </Text>
          <Text color='gray.600'>Esta empresa se encuentra temporalmente inactiva.</Text>
          <Text color='gray.600'>Para más información, contacte al administrador.</Text>
        </VStack>
      </Box>
    );
  }

  return (
    <>
      {!reservation && (
        <Box mb={4} display={'flex'} flexDirection={'column'}>
          <div>
            {user?.company?.others?.populateForm?.isActive && (
              <Button
                onClick={handlePopulateForm}
                loadingText='Cargando...'
                colorScheme='blue'
                size='sm'
              >
                Autocompletar formulario
              </Button>
            )}
          </div>

          <span>
            {t('reservation_form.title_chunk_1')}
            <span style={{ fontWeight: 'bold' }}> {t('reservation_form.title_chunk_2')}</span>.{' '}
            {t('reservation_form.title_chunk_3')}
            <span style={{ fontWeight: 'bold' }}> {t('reservation_form.title_chunk_4')} </span>
            {t('reservation_form.title_chunk_5')}
            <Button
              onClick={() => {
                changeForm(FormType.VALIDATE_RESERVATION);
              }}
              pl={1}
              colorScheme='black'
              variant='link'
              textDecoration={'underline'}
            >
              {t('reservation_form.title_chunk_6')}
            </Button>
          </span>
        </Box>
      )}

      <form onSubmit={handleSubmit(onSubmit)}>
        <SimpleGrid mt={4} columns={{ sm: 1, md: 3 }} spacing={5}>
          {fields.map((field) => {
            if (
              field.type === FormFieldType.TEXT ||
              field.type === FormFieldType.EMAIL ||
              field.type === FormFieldType.NUMBER
            ) {
              return (
                <FormControl
                  key={field.slug}
                  isInvalid={handleIsInvalidField(errors?.[field.slug ?? '']?.message)}
                >
                  <FormLabel htmlFor='name'>
                    {field.name[(reservation?.lang as 'es' | 'en') ?? lang ?? 'es']}{' '}
                    {field.required ? '*' : ''}
                  </FormLabel>
                  <InputGroup>
                    <Input
                      placeholder={
                        field?.placeholder[(reservation?.lang as 'es' | 'en') ?? lang ?? 'es']
                      }
                      type={field.type.toString()}
                      pr={puedeBuscarCliente(field.slug) ? '2.5rem' : undefined}
                      {...register(field.slug ?? '')}
                      onBlur={() => {
                        if (field?.slug == 'email') {
                          setValue('email', watchEmail?.toString().trim());
                        }
                        if (field?.slug == 'emailConfirmation') {
                          setValue('emailConfirmation', watchEmailConfirmation?.toString().trim());
                        }
                      }}
                    />
                    {/* Solo dentro del panel: buscar a alguien que ya vino y
                        traer sus datos, en vez de teclearlos otra vez. */}
                    {puedeBuscarCliente(field.slug) && (
                      <InputRightElement>
                        <Tooltip label='Buscar un cliente anterior' openDelay={400} fontSize='xs'>
                          <IconButton
                            aria-label='buscar un cliente anterior'
                            icon={<FiSearch />}
                            size='sm'
                            variant='ghost'
                            colorScheme='blue'
                            tabIndex={-1}
                            onClick={() => setBuscandoCliente(true)}
                          />
                        </Tooltip>
                      </InputRightElement>
                    )}
                  </InputGroup>
                  <FormErrorMessage>{errors?.[field.slug ?? '']?.message}</FormErrorMessage>
                </FormControl>
              );
            } else if (field.type === FormFieldType.SELECT) {
              return (
                <FormControl
                  key={field.slug}
                  isInvalid={handleIsInvalidField(errors?.[field.slug ?? '']?.message)}
                >
                  <FormLabel htmlFor='name'>
                    {field.name[(reservation?.lang as 'es' | 'en') ?? lang ?? 'es']}{' '}
                    {field.required ? '*' : ''}
                  </FormLabel>
                  <Select
                    placeholder={
                      ((reservation?.lang as 'es' | 'en') ?? lang ?? 'es') == 'es'
                        ? 'Seleccione una opción'
                        : 'Select option'
                    }
                    {...register(field.slug ?? '')}
                  >
                    {(field?.options ?? []).map((option) => {
                      return (
                        <option
                          key={option.id}
                          value={option.value[(reservation?.lang as 'es' | 'en') ?? lang ?? 'es']}
                        >
                          {option.value[(reservation?.lang as 'es' | 'en') ?? lang ?? 'es']}
                        </option>
                      );
                    })}
                  </Select>
                  <FormErrorMessage>{errors?.[field.slug ?? '']?.message}</FormErrorMessage>
                </FormControl>
              );
            } else {
              return <Box key={field.slug}></Box>;
            }
          })}

          <FormControl isInvalid={handleIsInvalidField(errors.numberPeople?.message)}>
            <FormLabel htmlFor='numberPeople'>
              {t('reservation_form.input_number_persons')} *
            </FormLabel>
            <Input
              type={'number'}
              borderColor={'black'}
              {...register('numberPeople')}
              maxLength={2}
            />
            <FormErrorMessage>{errors.numberPeople?.message}</FormErrorMessage>
          </FormControl>
          {locations?.length > 1 && (
            <FormControl isInvalid={handleIsInvalidField(errors.location?.message)}>
              <FormLabel htmlFor='location'>{t('reservation_form.input_location_2')}*</FormLabel>
              <Select
                disabled={!watchNumberPeople || locations.length == 1}
                borderColor={'black'}
                placeholder={t('general.select_option') ?? ''}
                {...register('location')}
              >
                {locations.map((location) => {
                  return (
                    <option key={location.id} value={location.id}>
                      {`${location.name} (${location.address})`}
                    </option>
                  );
                })}
              </Select>
              <FormErrorMessage>{errors.location?.message}</FormErrorMessage>
            </FormControl>
          )}

          <FormControl isInvalid={handleIsInvalidField(errors.date?.message)}>
            <FormLabel htmlFor='date'>{t('reservation_form.input_date')} *</FormLabel>
            <Input
              disabled={!watchLocation}
              borderColor={'black'}
              type={'date'}
              min={format(
                user?.role && reservation?.location ? subDays(new Date(), 3) : new Date(),
                'yyyy-MM-dd'
              )}
              {...register('date')}
            />
            <FormErrorMessage>{errors.date?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={handleIsInvalidField(errors.startHour?.message)}>
            <FormLabel htmlFor='startHour'>
              {t('reservation_form.input_hour')} {isEndDateEnable ? 'inicio' : ''} *
            </FormLabel>

            <Select
              disabled={!watchDate}
              width={'100%'}
              placeholder='--:--'
              {...register('startHour')}
            >
              {startHours.map((hour) => {
                return (
                  <option disabled={hour.disabled} key={hour.value} value={hour.value}>
                    {hour.label}
                  </option>
                );
              })}
            </Select>

            <FormErrorMessage mt={1} p={0}>
              {errors.startHour?.message}
            </FormErrorMessage>

            <FormHelperText fontSize={12} mt={1} p={0}>
              {watchDate && helpTextHour?.[1] && <Text>{helpTextHour?.[1]} </Text>}
              {watchDate && helpTextHour?.[0] && <Text as='b'>{helpTextHour?.[0]} </Text>}
            </FormHelperText>
          </FormControl>
          {isEndDateEnable && (
            <FormControl isInvalid={handleIsInvalidField(errors.endHour?.message)}>
              <FormLabel htmlFor='endHour'>{t('reservation_form.input_hour')} fin *</FormLabel>

              <Select
                disabled={!watchStartHour}
                width={'100%'}
                placeholder='--:--'
                {...register('endHour')}
              >
                {endHours.map((hour) => {
                  return (
                    <option disabled={hour.disabled} key={hour.value} value={hour.value}>
                      {hour.label}
                    </option>
                  );
                })}
              </Select>

              <FormErrorMessage mt={1} p={0}>
                {errors.endHour?.message}
              </FormErrorMessage>
            </FormControl>
          )}
        </SimpleGrid>

        {puedeRepetir && (
          <Box
            mt={8}
            p={3}
            borderWidth='1px'
            borderColor={esRecurrente ? 'blue.300' : 'gray.200'}
            bg={esRecurrente ? 'blue.50' : 'transparent'}
            borderRadius='md'
            transition='all .15s'
          >
            <Checkbox
              isChecked={esRecurrente}
              onChange={(e) => setEsRecurrente(e.target.checked)}
              colorScheme='blue'
            >
              <Text fontSize='sm' fontWeight='medium'>
                Esta reserva se repite
              </Text>
            </Checkbox>
            <Text fontSize='xs' color='gray.600' mt={1} ml={6}>
              {esRecurrente
                ? 'Al guardar elegirás los días y hasta cuándo, y verás si alguna fecha está ocupada.'
                : 'Márcalo si el cliente quiere la misma sala y hora varios días.'}
            </Text>
          </Box>
        )}

        <HStack mt={10} justifyContent={'center'}>
          <SimpleGrid>
            <FormControl isInvalid={handleIsInvalidField(errors.acceptTermsConditions?.message)}>
              <Checkbox
                border={'black'}
                isInvalid={handleIsInvalidField(
                  errors?.acceptTermsConditions?.message || errors?.acceptTermsConditions?.message
                )}
                {...register('acceptTermsConditions')}
              >
                {t('reservation_form.checkbox_terms_1')}{' '}
                <Link
                  color='black'
                  fontWeight={'bold'}
                  target={'_blank'}
                  href={
                    companyId == 'd5Un3CoVZmGVy6F4gBhE'
                      ? 'https://noi.work/wp-content/uploads/2023/05/NOI-tratamiento-de-datos-personales.pdf'
                      : 'https://dellanonna.com.co/wp-content/uploads/2019/08/POLI%CC%81TICA-DE-TRATAMIENTO-DE-DATOS-DELLA-NONNA-TRATTORIA.pdf'
                  }
                >
                  {t('reservation_form.checkbox_terms_2')}
                </Link>{' '}
              </Checkbox>
            </FormControl>
            <FormControl isInvalid={handleIsInvalidField(errors.acceptReceiveNews?.message)}>
              <Checkbox
                border={'black'}
                isInvalid={handleIsInvalidField(
                  errors?.acceptReceiveNews?.message || errors?.acceptReceiveNews?.message
                )}
                {...register('acceptReceiveNews')}
              >
                {t('reservation_form.checkbox_newsletter')}
              </Checkbox>
            </FormControl>
          </SimpleGrid>
        </HStack>
        {/* El indicador va DENTRO del botón. Antes el botón desaparecía y lo
            sustituía un spinner suelto, así que al guardar se movía todo y
            costaba saber si había pasado algo. El aviso de "no cierres la
            ventana" se mantiene, pero debajo, sin descolocar nada. */}
        <VStack mt={10} spacing={2}>
          <Button
            type='submit'
            colorScheme='blue'
            isLoading={isLoading}
            loadingText={
              reservation ? t('general.button_update') : t('reservation_form.button_submit')
            }
          >
            {reservation ? t('general.button_update') : t('reservation_form.button_submit')}
          </Button>
          {isLoading && (
            <Text fontSize='xs' color='gray.500' textAlign='center'>
              {t('reservation_form.text_creating_booking')}
            </Text>
          )}
          {/* Al modificar no se pasa a la pantalla de confirmación (se queda
              aquí con un aviso), así que el botón de calendario va en esta
              misma pantalla. De paso sirve a quien abre su reserva desde el
              correo solo para guardarla. Solo pinta si la empresa lo activó. */}
          {reservation && (reservation as { id?: string }).id && (
            <AgregarACalendario
              reservation={reservation as unknown as Reservation}
              reservationId={(reservation as { id?: string }).id as string}
              botonProps={{ variant: 'ghost', colorScheme: 'blue', size: 'sm', mt: 1 }}
            />
          )}
        </VStack>
      </form>
      <BuscarCliente
        isOpen={buscandoCliente}
        onClose={() => setBuscandoCliente(false)}
        companyId={user?.company?.id ?? companyId}
        onElegir={rellenarConCliente}
      />

      <Modal onClose={onClose} size={'md'} isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Ya tienes una reserva </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            Tenemos una reserva confirmada en la misma ubicación y fecha que ha solicitado.
            Lamentablemente, debido a esta reserva previa, no podemos procesar su solicitud para esa
            fecha y lugar específico, sin embargo puede cancelar o modificar su reserva actual
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' onClick={_onGoReservation} mr={3}>
              Ir a mi reserva
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ReservationForm;
